import { DropdownButton, MenuItem } from 'react-bootstrap';
import type { Role } from '../../../../../typings/api';
import { RoleScope } from '../../../../../typings/enums';
import { roleLabel, roleOptions } from '../../../../helpers/role';
import Tooltip from '../../../generic/Tooltip';

type TeamRoleSelectorProps = {
  roles: { [key in number | string]: Role };
  userId: number;
  roleId: number;
  teamId: number;
  disabled: boolean;
  onSetUserRole(roleId: number): void;
};

const permissionTooltipMessage = (userIsSelf: boolean) =>
  `You are not permitted to ${userIsSelf ? 'change your own role in a team.' : 'manage users on this team.'}`;

const TeamRoleSelector = (props: TeamRoleSelectorProps) => {
  const roleName = roleLabel(props.roles, props.roleId);

  if (props.disabled) {
    return (
      <Tooltip tooltip={permissionTooltipMessage(props.userId === window.user?.id)}>
        <span>{roleName}</span>
      </Tooltip>
    );
  }

  return (
    <DropdownButton
      id={`role-select-${props.userId}-${props.teamId}`}
      className="team-role-dropdown"
      title={roleName}
      bsStyle="link"
    >
      {roleOptions(props.roles, RoleScope.Team).map(({ value, label }) => (
        <MenuItem key={value} active={value === props.roleId} onSelect={() => props.onSetUserRole(value)}>
          {label}
        </MenuItem>
      ))}
    </DropdownButton>
  );
};

export default TeamRoleSelector;
